module.exports = __webpack_public_path__ + "img/zhjq2_image.088fa238.png";